module.exports = __webpack_public_path__ + "static/media/feature1.9cc45579.png";